/**
 * 应用入口模块。
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./styles/tailwind.css";
import App from "./App";
import { GTMProvider } from "./components/GTMProvider";
import reportWebVitals from "./reportWebVitals";
import { printBuildInfo } from "./utils/build-info";

// 在任何业务代码运行前先打印一次，便于在线上 / 测试环境一眼确认 bundle 版本。
printBuildInfo();

// import store from './app/store'
// Sentry.init({
//   dsn: "https://622f12cf5cd2428294b826ddb418fdd4@sentry.cuixu.cn/2",
//   integrations: [new BrowserTracing()],

//   tracesSampleRate: 1.0,
// });

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<GTMProvider>
				<App />
			</GTMProvider>
		</BrowserRouter>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
